(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.gr-tab');
    if (!tab) return;
    var root = tab.closest('[data-gr]');
    root.querySelectorAll('.gr-tab').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      root.querySelector('#' + t.getAttribute('aria-controls')).hidden = !on;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
